// extracted by mini-css-extract-plugin
export var actionButton = "_6y-1";
export var actionButtons = "_6y-2";
export var actions = "_6y-0";
export var aiUnread = "_6y-10";
export var alignCenter = "_6y-h";
export var backWrapper = "_6y-3";
export var cellContainer = "_6y-4";
export var checkboxContainer = "_6y-5";
export var contentContainer = "_6y-6";
export var contentHeader = "_6y-8";
export var conversationsTableWrapper = "_6y-s";
export var draftReplyBadgeContainer = "_6y-m";
export var dropdownItem = "_6y-b";
export var dropdownItemsContainer = "_6y-a";
export var dropdownTitle = "_6y-c";
export var errorIcon = "_6y-7";
export var filter = "_6y-d";
export var gray = "_6y-i";
export var headerActionButtons = "_6y-e";
export var headerCheckboxContainer = "_6y-f";
export var icon = "_6y-j";
export var menuContainer = "_6y-k";
export var noMoreTicketsIcon = "_6y-12";
export var noMoreTicketsSubText = "_6y-13";
export var oneLine = "_6y-l";
export var optionsButton = "_6y-n";
export var plus = "_6y-o";
export var portalButtonsWrapper = "_6y-g";
export var red = "_6y-p";
export var scrolledTop = "_6y-9";
export var search = "_6y-q";
export var selectedConversationsCount = "_6y-r";
export var spinner = "_6y-t";
export var strong = "_6y-u";
export var summaryCell = "_6y-v";
export var tableContainer = "_6y-11";
export var tagContainer = "_6y-w";
export var threeDots = "_6y-x";
export var twoLines = "_6y-y";
export var unread = "_6y-z";